import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMediaQuery } from '@react-hookz/web';
import { useBreakpointUp } from '@travel-frontend/core';
import { IconApps } from '@travel-frontend/icons';
import { forwardRef } from 'react';
import { Container } from '../../../../components/ImageGalleryLayer/components/BackToOverview/Container.js';
export const BackToOverview = forwardRef(({
  handleOverview,
  label,
  ...restProps
}, ref) => {
  const mdUp = useBreakpointUp('md');
  const isMobile = useMediaQuery('(max-device-width: 932px)');
  const isLandscape = useMediaQuery('(orientation: landscape)');
  const renderSlider = !(isMobile && isLandscape);
  return _jsxs(Container, {
    direction: "row",
    spacing: "xSmall",
    onClick: handleOverview,
    alignItems: "center",
    ref: ref,
    ...restProps,
    children: [_jsx(IconApps, {}), mdUp && renderSlider && label && _jsx("div", {
      children: label
    })]
  });
});